import React, { useCallback, useState } from 'react';
import { withToastManager } from 'react-toast-notifications';
import styled from 'styled-components';
import { FiCalendar, FiCheck, FiEdit, FiX } from 'react-icons/fi';
import { Box, Button } from 'rebass';
import ParticipantInputElement from './ParticipantInputElement';
import helpers from 'utils/helpers';
import { ProtectedField, useProtectedCompactRender } from 'components/ProtectedField';

export const AttributeItemWrapper = styled.div`
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    min-height: 52px;
    border-bottom: 1px solid #495f781f;
    color: #929db0;
    &:hover {
        background: #fbfdff;
    }
    & > div {
        padding: 8px 0;
    }
`;

function ParticipantAttrubuteItemWrapper({ cdk, cdv, onChange, person, className, onUnmask }) {
    const compactRender = useProtectedCompactRender();
    const [isUnmasked, setIsUnmasked] = useState(false);
    const [editing, setEditing] = useState(false);

    const isEditable = helpers.isEditableAttribute(cdk.title) && (!cdk.pii_masked || isUnmasked || cdv.value);

    const handleUnmask = useCallback(value => {
        setIsUnmasked(true);
        onUnmask({ target: { name: cdk.id, value: value } });
    }, []);

    const handleChange = useCallback(e => {
        const value = e.target.type === 'checkbox' ? helpers.getCheckboxValuesAsArray(cdk.id) : e.target.value;
        setEditing(value);
    }, []);

    const handleClickEdit = e => {
        e.preventDefault();
        setEditing(cdv.value);
    };

    const handleClickCancel = e => {
        e.preventDefault();
        setEditing(false);
    };

    const handleClickSave = e => {
        e.preventDefault();
        setEditing(false);
        onChange({ target: { name: cdk.id, type: cdk.type, value: editing } });
    };

    return (
        <AttributeItemWrapper className={className} style={{ paddingLeft: 0, paddingRight: 0 }}>
            <Box width={5 / 16} className="color-text-primary medium">
                {cdk.title}
            </Box>
            <Box width={7 / 16} className="color-text-primary">
                {editing === false ? (
                    <ProtectedField
                        dataKey={cdk.title}
                        person={person}
                        onHide={() => setIsUnmasked(false)}
                        onDiscover={handleUnmask}
                        hideable
                        render={compactRender}
                        empty="-"
                    />
                ) : (
                    <ParticipantInputElement
                        cdv={{ value: editing }}
                        cdk={cdk}
                        onCancel={handleClickCancel}
                        onSave={handleClickSave}
                        onChange={handleChange}
                    />
                )}
            </Box>
            <Box width={4 / 16} className="text-right">
                {isEditable &&
                    (editing === false ? (
                        <Button variant="transparent" onClick={handleClickEdit}>
                            {cdk.type === 'date' ? (
                                <>
                                    <FiCalendar />
                                    Set date
                                </>
                            ) : (
                                <>
                                    <FiEdit />
                                    Edit
                                </>
                            )}
                        </Button>
                    ) : (
                        <>
                            <Button variant="transparent" onClick={handleClickCancel}>
                                <FiX />
                                Cancel
                            </Button>
                            <Button variant="primary-transparent" className="primary !ml-1" onClick={handleClickSave}>
                                <FiCheck />
                                Save
                            </Button>
                        </>
                    ))}
            </Box>
        </AttributeItemWrapper>
    );
}

export default withToastManager(ParticipantAttrubuteItemWrapper);
